<template>
  <div class="container overflow-x-scroll lg:overflow-x-visible mt-8">
    <progress-report-header
      :can-edit="canEdit"
      :incomplete="incompleteEntry"
      :intervals="intervals"
    />
    <div class="card is-borderless mt-2 min-w-xl lg:min-w-0 mr-6 lg:mr-0">
      <progress-report-row
        v-for="item in items"
        :key="item.id"
        :can-edit="canEdit"
        :is-monitor="isMonitor"
        :is-msp="isMsp"
        :item="item"
        :entries="getEntries(item.id)"
        @progress:save="update"
      />
      <progress-report-documents
        :is-monitor="isMonitor"
        :is-msp="isMsp"
        :can-edit="canEdit"
        :documents="documents"
        :intervals="intervals"
      />
    </div>
    <p class="pl-4 text-xs text-grey-400 mt-4">
      {{ lastUpdated || "" }}
    </p>
  </div>
</template>

<script>
import format from "date-fns/format";
import parseISO from "date-fns/parseISO";
import debounce from "lodash/debounce";
import flatten from "lodash/flatten";
export default {
  name: "ProgressReport",
  props: {
    isMsp: {
      type: [Boolean, Function],
      default: false
    },
    isMonitor: {
      type: Boolean,
      default: false
    },
    canEdit: {
      type: [Boolean, Function],
      default: false
    },
    monitoring: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      lastUpdated: null,
      entries: []
    };
  },
  computed: {
    items() {
      return this.monitoring.items;
    },
    documents() {
      return this.monitoring.documents;
    },
    intervals() {
      if (!this.entries) return;
      return this.entries.reduce((interval, entry) => {
        const {
          open_date,
          partner_can_provide_feedback,
          monitor_can_provide_feedback,
          partner_can_upload_files,
          monitor_can_upload_files,
          requires_monitor_feedback,
          requires_claim_review,
          msp_can_provide_feedback,
          requires_msp_feedback,
        } = entry[0];
        const formattedID = format(parseISO(open_date), "LLyy");
        const formattedDate = format(parseISO(open_date), "LL/yy");
        interval.push({
          id: formattedID,
          date: formattedDate,
          open_date,
          partner_can_provide_feedback,
          monitor_can_provide_feedback,
          partner_can_upload_files,
          monitor_can_upload_files,
          requires_monitor_feedback,
          requires_claim_review,
          msp_can_provide_feedback,
          requires_msp_feedback,
        });
        return interval;
      }, []);
    },
    openEntries() {
      return this.entries.reduce((arr, interval) => {
        if (interval.some(entry => entry.partner_can_provide_feedback)) {
          arr.push(...interval);
        }
        return arr;
      }, []);
    },
    incompleteEntry() {
      let errors = this.openEntries.reduce((err, entry) => {
        if (entry.partner_status === 3) return err;
        if (entry.partner_status < 3 && entry.partner_feedback) return err;
        err++;
        return err;
      }, 0);
      return errors > 0;
    }
  },
  created() {
    this.entries = this.monitoring.entries;
  },
  methods: {
    getEntries(id) {
      return this.entries.reduce((entries, entry) => {
        entries.push(
          ...entry.filter(e => e.competition_monitoring_item_id === id)
        );
        return entries;
      }, []);
    },
    update(data) {
      if (data.type === "msp") {
        return this.updateMSPEntry(data);
      }
      if (data.type === "monitor") {
        return this.updateMonitorEntry(data);
      }
      return this.updatePartnerEntry(data);
    },
    updatePartnerEntry({ id, partner_status, partner_feedback }) {
      if (!this.canEdit) return;
      const entries = flatten(this.entries);
      const entry = entries.find(entry => entry.id === id);
      entry.partner_status = partner_status;
      entry.partner_feedback = partner_feedback;
      this.saveEntry({ id, type: 'partner', status: partner_status, feedback: partner_feedback }, this);
    },
    updateMonitorEntry({ id, monitor_status, monitor_feedback }) {
      if (!this.isMonitor) return;
      const entries = flatten(this.entries);
      const entry = entries.find(entry => entry.id === id);
      entry.monitor_status = monitor_status;
      entry.monitor_feedback = monitor_feedback;
      this.saveEntry({ id, type: 'monitor', status: monitor_status, feedback: monitor_feedback }, this);
    },
    updateMSPEntry({ id, msp_status, msp_feedback }) {
      if (!this.isMsp) return;
      const entries = flatten(this.entries);
      const entry = entries.find(entry => entry.id === id);
      entry.msp_status = msp_status;
      entry.msp_feedback = msp_feedback;
      this.saveEntry({ id, type: 'msp', status: msp_status, feedback: msp_feedback }, this);
    },
    saveEntry: debounce((entry, self) => {
      axios
        .patch(window.location, entry)
        .then(() => {
          self.lastUpdated = "Last Saved: " + format(new Date, "dd/mm/yy hh:mm:ss");
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.error(e);
          alert( "There was an error trying to save your progress report, please try again later.")
        });
    }, 300)
  }
};
</script>
